class navbarItem {
    constructor(title="test",link="",isActive = true,list = []) {
        this.title = title;
        // Used for mobile vue or when no children list
        this.link = link;
        this.isActive = isActive;
        this.list = list;
    }
}
export default navbarItem;